import styled from 'styled-components';

import { FormGrid } from '../../style';

export const SpacedFormGrid = styled(FormGrid)`
  margin-top: 16px;
`;

export const PriceScroll = styled.div`
  margin-top: 16px;
  overflow-x: auto;
`;

export const PriceGrid = styled.div`
  display: grid;
  grid-template-columns: 150px 190px 110px 190px 150px 150px;
  gap: 24px;
  align-items: center;
  min-width: 990px;
  margin-top: 8px;
`;

export const PriceColHead = styled(PriceGrid)`
  margin-top: 0;

  span {
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: #94A3B8;
  }
`;

export const PriceValue = styled.span`
  font-size: 16px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
`;

export const PriceCaption = styled.p`
  margin: 8px 0 0;
  font-size: 12.5px;
  color: #94A3B8;
`;
